'use client';

import { BN, DriftClient, PerpMarketConfig, User } from '@drift-labs/sdk';
import { useAccountTradingDataSync } from './useAccountTradingDataSync';
import { useTriggeredOrderNotifications } from './useTriggeredOrderNotifications';

type Props = {
	userKey: string;
	user: User;
	driftClient: DriftClient;
	perpMarketsLookup: PerpMarketConfig[];
	markPriceCallback: (marketIndex: number) => BN;
};

/**
 * Per-account component that syncs trading data to React Query cache
 * and handles side effects (triggered order notifications).
 *
 * One instance is rendered per subaccount by AccountTradingDataProvider.
 */
export default function AccountTradingDataSync({
	userKey,
	user,
	driftClient,
	perpMarketsLookup,
	markPriceCallback,
}: Props) {
	// Push all trading data to RQ cache (event-driven + polling fallback)
	useAccountTradingDataSync(
		userKey,
		user,
		driftClient,
		perpMarketsLookup,
		markPriceCallback
	);

	useTriggeredOrderNotifications(userKey, user);

	return null;
}
